module.exports = __webpack_public_path__ + "img/react.cccd4abe.jpg";